// userInteractionSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { generateUniqueId } from 'utils/commonFunctions';
import { QUIZ_PLAYED_ATLEAST_ONCE, WISDEN_QUIZ_NEWSLETTER_SUBSCRIBED } from 'utils/constants';

export const userInteractionSlice = createSlice({
  name: 'userInteraction',
  initialState: {
    [WISDEN_QUIZ_NEWSLETTER_SUBSCRIBED]: false,
    [QUIZ_PLAYED_ATLEAST_ONCE]: false
  },
  reducers: {
    setQuizPlayedOnce: (state, { payload }) => {
      state[QUIZ_PLAYED_ATLEAST_ONCE] = payload;
    },
    setNewsletterSub: (state, { payload }) => {
      state[WISDEN_QUIZ_NEWSLETTER_SUBSCRIBED] = payload;
    }
  }
});

export const { setNewsletterSub, setQuizPlayedOnce } = userInteractionSlice.actions;

export const isNewsletterSubbed = (state) =>
  state.userInteractionSlice[WISDEN_QUIZ_NEWSLETTER_SUBSCRIBED];

export const hasPlayedQuizAtleastOnce = (state) =>
  state.userInteractionSlice[QUIZ_PLAYED_ATLEAST_ONCE];

export default userInteractionSlice.reducer;
